export function ViewRendererComponent({ data, onEdit}: any) {
  return (
    <div className="flex justify-center items-center">
      <button
        onClick={() => {onEdit(data)}}
        className="text-blue-500 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            d="M12 4.5C7.026 4.5 2.753 8.063 1 12c1.753 3.937 6.026 7.5 11 7.5s9.247-3.563 11-7.5C21.247 8.063 16.974 4.5 12 4.5zM12 16.5c-2.485 0-4.5-2.015-4.5-4.5s2.015-4.5 4.5-4.5 4.5 2.015 4.5 4.5-2.015 4.5-4.5 4.5z"
          />
          <path
            d="M12 9c-1.656 0-3 1.343-3 3s1.344 3 3 3 3-1.343 3-3-1.344-3-3-3z"
          />
        </svg>
      </button>
    </div>
  );
}